<template>
  <b-overlay :show="loading || saving">
    <div class="employment-details-container p-4">
      <div class="card shadow-sm border-0">
        <div
          class="card-header bg-light-blue py-3 d-flex justify-content-between align-items-center border-bottom"
        >
          <div class="text-center flex-grow-1">
            <!-- Updated by Jarir 2026-03-30 : Added Bangladesh Gazette header -->
            <p
              class="mb-1 font-weight-bold"
              style="color: #333; font-size: 0.85rem"
            >
              Bangladesh Gazette - বাংলাদেশ গেজেট
            </p>
            <h5 class="mb-1 font-weight-bold text-primary">Form No: 07</h5>
            <p class="mb-1 text-muted small">
              Under Section 7, Rules (1) and (2)
            </p>
            <p class="mb-1 text-muted small">Second Part (B)</p>

            <h6 class="mb-0 font-weight-bold">Employer and Employment details</h6>
            <p class="mb-0 small bn-text">মালিকের ও চাকরির তথ্য</p>
          </div>
          <b-button variant="primary" @click="openAddModal" class="add-entry-btn" v-if="$acl && $acl['admin-service-book/employment-details'] == 2">
            <i class="fa fa-plus mr-2"></i> Add
          </b-button>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-bordered mb-0 custom-table">
              <thead class="text-center bg-light-cyan">
                <tr>
                  <th
                    @click="sortBy('factory_name_address')"
                    :class="
                      sortKey == 'factory_name_address'
                        ? sortOrders['factory_name_address'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Factory/Organization Name & Address<br />
                    <small class="bn-text"
                      >কারখানার/প্রতিষ্ঠানের নাম ও ঠিকানা</small
                    >
                  </th>
                  <th
                    @click="sortBy('owner_authority_name')"
                    :class="
                      sortKey == 'owner_authority_name'
                        ? sortOrders['owner_authority_name'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Owner/ Management Authority Name<br />
                    <small class="bn-text"
                      >মালিক/ব্যবস্থাপনা কর্তৃপক্ষের নাম</small
                    >
                  </th>
                  <th
                    @click="sortBy('joining_date')"
                    :class="
                      sortKey == 'joining_date'
                        ? sortOrders['joining_date'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Joining Date<br />
                    <small class="bn-text">যোগদানের তারিখ</small>
                  </th>
                  <th
                    @click="sortBy('resignation_termination_date')"
                    :class="
                      sortKey == 'resignation_termination_date'
                        ? sortOrders['resignation_termination_date'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Resignation/ Termination Date<br />
                    <small class="bn-text">চাকরির ত্যাগ/অবসানের তারিখ</small>
                  </th>
                  <th
                    @click="sortBy('reason_of_termination')"
                    :class="
                      sortKey == 'reason_of_termination'
                        ? sortOrders['reason_of_termination'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Type/Reason of Resignation or Termination<br />
                    <small class="bn-text">ত্যাগ/অবসানের ধরণ/কারণ</small>
                  </th>
                  <th>
                    Signature of Owner/ Authorized Person<br />
                    <small class="bn-text"
                      >মালিক/প্রাধিকারপ্রান্ত ব্যক্তির স্বাক্ষর</small
                    >
                  </th>
                  <th>
                    Worker’s Signature<br />
                    <small class="bn-text">শ্রমিকের স্বাক্ষর</small>
                  </th>
                  <th>
                    Thumb Impression<br />
                    <small class="bn-text">টিপসই</small>
                  </th>
                  <th v-if="$acl && $acl['admin-service-book/employment-details'] == 2">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paginatedData.length == 0 && !loading">
                  <td :colspan="$acl && $acl['admin-service-book/employment-details'] == 2 ? 9 : 8" class="text-center py-5 text-muted">
                    No records found.
                    <!-- Updated: 2026-04-19 18:45:00 -->
                    <br><span class="bn-text">কোন তথ্য পাওয়া যায়নি</span>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in paginatedData"
                  :key="item.id"
                  class="text-center"
                >
                  <td>
                    <div class="text-left">
                      <div class="font-weight-bold">
                        {{ getJsonValue(item.factory_name_address, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.factory_name_address, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-left">
                      <div class="font-weight-bold">
                        {{ getJsonValue(item.owner_authority_name, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.owner_authority_name, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    {{ formatDate(item.joining_date) }}
                    <br v-if="item.id == activeRecordId" />
                    <span
                      v-if="item.id == activeRecordId"
                      style="color: #28a745; font-size: 11px"
                      >&#10004; (Active)</span
                    >
                  </td>
                  <td>{{ formatDate(item.resignation_termination_date) }}</td>
                  <td>
                    <div class="text-left">
                      <div>
                        {{ getJsonValue(item.reason_of_termination, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.reason_of_termination, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <b-link v-if="item.owner_signature" @click="downloadWithName(item.owner_signature, 'Owner_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <!-- Updated by Jarir 2026-03-30 -->
                    <span v-else class="text-muted small"
                      >No Signatories found. Add a Signatory in HR Management Portal</span
                    >
                  </td>
                  <td>
                    <b-link v-if="item.worker_signature" @click="downloadWithName(item.worker_signature, 'Worker_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <span v-else></span>
                  </td>
                  <td>
                    <b-link v-if="item.worker_thumb_impression" @click="downloadWithName(item.worker_thumb_impression, 'Thumb_Impression')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <span v-else></span>
                  </td>
                  <!-- <td>
                    <b-dropdown
                      size="sm"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template #button-content>
                        <i class="fa fa-ellipsis-v text-muted"></i>
                      </template>
                      <b-dropdown-item @click="editItem(item)"
                        ><i class="fa fa-edit mr-2 text-primary"></i>
                        Edit</b-dropdown-item
                      >
                      <b-dropdown-item @click="confirmDelete(item.id)"
                        ><i class="fa fa-trash mr-2 text-danger"></i>
                        Delete</b-dropdown-item
                      >
                    </b-dropdown>
                  </td> -->
                    <td class="position-relative text-center" v-if="$acl && $acl['admin-service-book/employment-details'] == 2">
                      <template v-if="item.id !== activeRecordId">
                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-ellipsis-v text-muted"></i>
                        </a>
                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                            <b-button-toolbar class="">
                                <b-button-group class="mr-0">
                                    <b-button class="mr-3 rounded edit-btn" title="Edit" @click="editItem(item)">
                                        <i class="fa fa-edit mr-2 text-primary"></i>Edit
                                    </b-button>
                                    <b-button class="mr-3 rounded edit-btn" title="Delete" @click="confirmDelete(item.id)">
                                        <i class="fa fa-trash mr-2 text-danger"></i>Delete
                                    </b-button>
                                </b-button-group>
                            </b-button-toolbar>
                        </div>
                      </template>
                      <template v-else>
                        <span class="text-muted small">N/A</span>
                      </template>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="card-footer bg-white border-top py-3"
          v-if="pagination.pages > 1"
        >
          <b-pagination-nav
            v-model="pagination.currentPage"
            :number-of-pages="pagination.pages"
            base-url="#"
            prev-text="Previous"
            next-text="Next"
            first-number
            last-number
            align="center"
            class="mb-0"
          ></b-pagination-nav>
        </div>
      </div>

      <!-- Entry Modal -->
      <b-modal
        v-model="showModal"
        :title="isEdit ? 'Edit Employment Detail' : 'Add New Employment Detail'"
        @hidden="resetForm"
        size="lg"
        hide-footer
      >
        <form @submit.prevent="saveDetail" novalidate>
          <div class="row">
            <div class="col-md-6 border-right">
              <h6 class="font-weight-bold border-bottom pb-2 mb-3">
                English Details
              </h6>
              <!-- Updated by Jarir 2026-04-21 — autofetched fields locked via :readonly -->
              <b-form-group>
                <template #label>
                  Factory/Organization Name &amp; Address: <span class="text-danger">*</span>
                </template>
                <b-form-textarea
                  v-model="form.factory_name_address.en"
                  rows="3"
                  :readonly="isAutofetched"
                  :state="submitAttempted && !form.factory_name_address.en ? false : (form.factory_name_address.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.factory_name_address.en) ? false : null)"
                ></b-form-textarea>
                <!-- Updated by Jarir 2026-04-26 — real-time per-field error messages (empty + special-char-only) -->
                <b-form-invalid-feedback :state="submitAttempted && !form.factory_name_address.en ? false : null">Factory/Organization Name &amp; Address (English) is required</b-form-invalid-feedback>
                <b-form-invalid-feedback :state="form.factory_name_address.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.factory_name_address.en) ? false : null">Factory Name must contain letters or numbers</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Owner/Management Name: <span class="text-danger">*</span>
                </template>
                <b-form-input
                  v-model="form.owner_authority_name.en"
                  :readonly="isAutofetched"
                  :state="submitAttempted && !form.owner_authority_name.en ? false : (form.owner_authority_name.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.owner_authority_name.en) ? false : null)"
                ></b-form-input>
                <!-- Updated by Jarir 2026-04-26 — real-time per-field error messages (empty + special-char-only) -->
                <b-form-invalid-feedback :state="submitAttempted && !form.owner_authority_name.en ? false : null">Owner/Management Name (English) is required</b-form-invalid-feedback>
                <b-form-invalid-feedback :state="form.owner_authority_name.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.owner_authority_name.en) ? false : null">Owner/Management Name must contain letters or numbers</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="Reason for Termination:">
                <b-form-textarea
                  v-model="form.reason_of_termination.en"
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <h6 class="font-weight-bold border-bottom pb-2 mb-3 bn-text">
                বাংলা তথ্য
              </h6>
              <b-form-group label="কারখানার/প্রতিষ্ঠানের নাম ও ঠিকানা:">
                <b-form-textarea
                  v-model="form.factory_name_address.bn"
                  rows="3"
                  class="bn-text"
                  :readonly="isAutofetched"
                  :state="(form.factory_name_address.bn && !/[\u0980-\u09FF]/.test(form.factory_name_address.bn) ? false : null)"
                ></b-form-textarea>
                <!-- Updated by Jarir 2026-04-26 — real-time Bangla validation -->
                <b-form-invalid-feedback :state="form.factory_name_address.bn && !/[\u0980-\u09FF]/.test(form.factory_name_address.bn) ? false : null">Factory Name (Bangla) must contain Bangla letters</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="মালিক/ব্যবস্থাপনা কর্তৃপক্ষের নাম:">
                <b-form-input
                  v-model="form.owner_authority_name.bn"
                  class="bn-text"
                  :readonly="isAutofetched"
                  :state="(form.owner_authority_name.bn && !/[\u0980-\u09FF]/.test(form.owner_authority_name.bn) ? false : null)"
                ></b-form-input>
                <b-form-invalid-feedback :state="form.owner_authority_name.bn && !/[\u0980-\u09FF]/.test(form.owner_authority_name.bn) ? false : null">Owner/Management Name (Bangla) must contain Bangla letters</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="ত্যাগ/অবসানের ধরণ/কারণ:">
                <b-form-textarea
                  v-model="form.reason_of_termination.bn"
                  class="bn-text"
                  :state="form.reason_of_termination.bn && !/[\u0980-\u09FF]/.test(form.reason_of_termination.bn) ? false : null"
                ></b-form-textarea>
                <b-form-invalid-feedback :state="form.reason_of_termination.bn && !/[\u0980-\u09FF]/.test(form.reason_of_termination.bn) ? false : null">Termination Reason (Bangla) must contain Bangla letters</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-md-6">
              <b-form-group>
                <template #label>
                  Joining Date (যোগদানের তারিখ)
                  <span class="text-danger">*</span>
                </template>
                <b-input-group>
                  <b-form-input
                    v-model="form.joining_date"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    :readonly="isAutofetched"
                    :state="joiningDateState"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="form.joining_date"
                      button-only
                      right
                      locale="en-US"
                      :disabled="isAutofetched"
                      :max="maxJoiningDate"
                      :min="minJoiningDate"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback :state="joiningDateState">{{ joiningDateFeedback }}</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group>
                <template #label>
                  Termination Date (চাকরির ত্যাগ/অবসানের তারিখ)
                  <span v-if="!(isEdit && editId == activeRecordId)" class="text-danger">*</span>
                </template>
                <b-input-group>
                  <b-form-input
                    v-model="form.resignation_termination_date"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    :readonly="isAutofetched"
                    :state="terminationDateState"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="form.resignation_termination_date"
                      button-only
                      right
                      locale="en-US"
                      :disabled="isAutofetched"
                      :max="maxTerminationDate"
                      :min="minTerminationDate"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback :state="terminationDateState">{{ terminationDateFeedback }}</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="row mt-3 border-top pt-3">
            <div class="col-md-4 text-center">
              <label class="font-weight-bold small d-block"
                >Owner's Signature:</label
              >
              <div v-if="ownerSigPreview" class="mt-2 text-center">
                <b-link @click="downloadWithName(owner_signature_raw, 'Owner_Signature')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <!-- Updated by Jarir 2026-03-30 -->
              <div v-else class="text-muted small">
                No Signatories found. Add a Signatory in HR Management Portal
              </div>
              <b-form-select
                v-model="selected_signatory_id"
                :options="signatoryOptions"
                class="mt-2"
                size="sm"
                @change="onSignatoryChange"
              ></b-form-select>
            </div>
            <div class="col-md-4 text-center border-left">
              <label class="font-weight-bold small d-block"
                >Worker's Signature
                <span class="bn-text">(শ্রমিকের স্বাক্ষর)</span>:</label
              >
              <div v-if="workerSigPreview" class="mt-2 text-center">
                <b-link @click="downloadWithName(worker_signature_raw, 'Worker_Signature')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <div v-else class="text-muted small">No signature available</div>
            </div>
            <div class="col-md-4 text-center border-left">
              <label class="font-weight-bold small d-block"
                >Thumb Impression <span class="bn-text">(টিপসই)</span>:</label
              >
              <div v-if="thumbImpPreview" class="mt-2 text-center">
                <b-link @click="downloadWithName(thumb_impression_raw, 'Thumb_Impression')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <div v-else class="text-muted small">No impression available</div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-12 text-center">
              <p class="text-info small mb-0">
                <i class="fa fa-info-circle mr-1"></i> Signatures are
                automatically fetched from reference documents and are not
                modifiable here.
              </p>
            </div>
          </div>

          <!-- alpha fix- maked text-center  -->
          <div class="text-center mt-4 pt-3 border-top">
            <b-button
              variant="secondary"
              @click="showModal = false"
              class="mr-2 custom-wizard-btn"
              >Cancel</b-button
            >
            <b-button
              type="submit"
              variant="primary"
              :disabled="saving || dateError || (!isEdit && form.joining_date && oldestJoiningDate && form.joining_date >= oldestJoiningDate)"
            >
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </form>
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
export default {
  props: {
    isEmbedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // Updated by Jarir 2026-03-25 : switched to frontend sort/paginate using global mixin
    var columns = [
      { label: "Factory Name", name: "factory_name_address" },
      { label: "Owner Name", name: "owner_authority_name" },
      { label: "Joining Date", name: "joining_date", type: "date" },
      {
        label: "Termination Date",
        name: "resignation_termination_date",
        type: "date",
      },
      { label: "Reason", name: "reason_of_termination" },
    ];
    var sortOrders = {};
    columns.forEach(function (col) {
      sortOrders[col.name] = -1;
    });

    return {
      apiPrefix: "/admin-service-book",
      employee_id: null,
      items: [],
      loading: false,
      saving: false,
      showModal: false,
      isEdit: false,
      editId: null,
      // Updated by Jarir 2026-04-20 — only mark invalid fields after a submit attempt, not on empty open
      submitAttempted: false,
      baseUrl: window.location.origin,
      columns: columns,
      sortKey: "joining_date",
      sortOrders: sortOrders,
      length: 5,
      pagination: {
        currentPage: 1,
        total: "",
        nextPage: "",
        prevPage: "",
        from: "",
        to: "",
        pages: 1,
      },
      form: {
        factory_name_address: { en: "", bn: "" },
        owner_authority_name: { en: "", bn: "" },
        reason_of_termination: { en: "", bn: "" },
        joining_date: "",
        resignation_termination_date: "",
      },
      ownerSigFile: null,
      workerSigFile: null,
      thumbImpFile: null,
      ownerSigName: "",
      workerSigName: "",
      thumbImpName: "",
      ownerSigPreview: null,
      workerSigPreview: null,
      thumbImpPreview: null,
      owner_signature_raw: null,
      worker_signature_raw: null,
      thumb_impression_raw: null,
      signatories: [],
      selected_signatory_id: null,
      isAutofetched: false, // Updated by Jarir 2026-04-21
    };
  },
  computed: {

    // Updated by Jarir 2026-03-30
    signatoryOptions() {
      var options = [{ value: null, text: "Select Signatory" }];
      this.signatories.forEach(function (s) {
        options.push({
          value: s.id,
          text: s.name + " — " + (s.designation || ""),
        });
      });
      return options;
    },
    // Updated by Jarir 2026-03-24 : realtime date validation
    dateError() {
      if (
        this.form.joining_date &&
        this.form.resignation_termination_date &&
        this.form.joining_date >= this.form.resignation_termination_date
      ) {
        return true;
      }
      return false;
    },
    oldestJoiningDate() {
      if (this.isEdit && this.editId == this.activeRecordId) {
        return null;
      }
      let oldest = null;
      this.items.forEach((item) => {
        if (this.isEdit && item.id === this.editId) {
          return;
        }
        if (item.joining_date) {
          const dateStr = (item.joining_date + "").substring(0, 10);
          if (!oldest || dateStr < oldest) {
            oldest = dateStr;
          }
        }
      });
      return oldest;
    },
    dateLimits() {
      // Updated 2026-07-13 — active record comes from the backend's is_active flag, not from checking resignation_termination_date locally
      let active = (this.items || this.tableData || []).find(item => item.is_active == 1);
      let activeJoining = active ? String(active.joining_date).substring(0, 10) : null;

      let previousJobs = (this.items || this.tableData || [])
        .filter(item => item.resignation_termination_date && (!this.isEdit || item.id !== this.editId))
        .map(item => ({
          joining_date: String(item.joining_date).substring(0, 10),
          resignation_termination_date: String(item.resignation_termination_date).substring(0, 10)
        }));
      previousJobs.sort((a, b) => a.joining_date.localeCompare(b.joining_date));

      if (!this.isEdit) {
        let upperLimit = previousJobs.length > 0 ? previousJobs[0].joining_date : activeJoining;
        let limitStr = upperLimit ? this.addDays(upperLimit, -1) : null;
        return {
          joiningMax: limitStr,
          joiningMin: '1970-01-01',
          terminationMax: limitStr,
          terminationMin: '1970-01-01'
        };
      } else {
        if (this.editId === this.activeRecordId) {
          let newestPrev = previousJobs.length > 0 ? previousJobs[previousJobs.length - 1] : null;
          let minStr = newestPrev ? this.addDays(newestPrev.resignation_termination_date, 1) : '1970-01-01';
          return {
            joiningMax: null,
            joiningMin: minStr,
            terminationMax: null,
            terminationMin: null
          };
        } else {
          let origRecord = (this.items || this.tableData || []).find(item => item.id === this.editId);
          if (!origRecord) return { joiningMax: null, joiningMin: '1970-01-01', terminationMax: null, terminationMin: '1970-01-01' };

          let allPrev = (this.items || this.tableData || [])
            .filter(item => item.resignation_termination_date)
            .map(item => ({
              id: item.id,
              joining_date: String(item.joining_date).substring(0, 10),
              resignation_termination_date: String(item.resignation_termination_date).substring(0, 10)
            }));
          allPrev.sort((a, b) => a.joining_date.localeCompare(b.joining_date));

          let idx = allPrev.findIndex(item => item.id === this.editId);
          if (idx === -1) return { joiningMax: null, joiningMin: '1970-01-01', terminationMax: null, terminationMin: '1970-01-01' };

          let prevJob = idx > 0 ? allPrev[idx - 1] : null;
          let nextJob = idx < allPrev.length - 1 ? allPrev[idx + 1] : null;

          let jMin = prevJob ? this.addDays(prevJob.resignation_termination_date, 1) : '1970-01-01';

          let tMax = activeJoining;
          if (nextJob) {
            tMax = this.addDays(nextJob.joining_date, -1);
          } else if (activeJoining) {
            tMax = this.addDays(activeJoining, -1);
          }

          return {
            joiningMax: this.form.resignation_termination_date ? this.form.resignation_termination_date : tMax,
            joiningMin: jMin,
            terminationMax: tMax,
            terminationMin: this.form.joining_date ? this.form.joining_date : jMin
          };
        }
      }
    },
    maxJoiningDate() {
      return this.dateLimits.joiningMax;
    },
    minJoiningDate() {
      return this.dateLimits.joiningMin;
    },
    maxTerminationDate() {
      return this.dateLimits.terminationMax;
    },
    minTerminationDate() {
      return this.dateLimits.terminationMin;
    },
    joiningDateState() {
      if (this.submitAttempted && !this.form.joining_date) return false;
      if (this.form.joining_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.joining_date)) return false;
        if (this.form.joining_date < "1970-01-01") return false;
        if (this.minJoiningDate && this.form.joining_date < this.minJoiningDate) return false;
        if (this.maxJoiningDate && this.form.joining_date > this.maxJoiningDate) return false;
      }
      return null;
    },
    terminationDateState() {
      const isActive = this.isEdit && this.editId === this.activeRecordId;
      if (this.submitAttempted && !isActive && !this.form.resignation_termination_date) return false;
      if (this.form.resignation_termination_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.resignation_termination_date)) return false;
        if (this.form.joining_date && this.form.resignation_termination_date <= this.form.joining_date) return false;
        if (this.minTerminationDate && this.form.resignation_termination_date < this.minTerminationDate) return false;
        if (this.maxTerminationDate && this.form.resignation_termination_date > this.maxTerminationDate) return false;
      }
      return null;
    },
    joiningDateFeedback() {
      if (this.submitAttempted && !this.form.joining_date) return "Joining Date is required";
      if (this.form.joining_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.joining_date)) return "Joining Date must be in YYYY-MM-DD format";
        if (this.form.joining_date < "1970-01-01") return "Joining Date cannot be earlier than 1970-01-01";
        if (this.minJoiningDate && this.form.joining_date < this.minJoiningDate) {
          return "Joining Date must be after the previous job's resignation date (" + this.formatDate(this.minJoiningDate) + ")";
        }
        if (this.maxJoiningDate && this.form.joining_date > this.maxJoiningDate) {
          if (!this.isEdit) {
            return "Joining Date must be earlier than the oldest joining date (" + this.formatDate(this.maxJoiningDate) + ")";
          } else {
            return "Joining Date must be earlier than the next job's joining date (" + this.formatDate(this.maxJoiningDate) + ")";
          }
        }
      }
      return "";
    },
    terminationDateFeedback() {
      const isActive = this.isEdit && this.editId === this.activeRecordId;
      if (this.submitAttempted && !isActive && !this.form.resignation_termination_date) return "Termination Date is required";
      if (this.form.resignation_termination_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.resignation_termination_date)) return "Termination Date must be in YYYY-MM-DD format";
        if (this.form.joining_date && this.form.resignation_termination_date <= this.form.joining_date) {
          return "Termination Date must be after Joining Date";
        }
        if (this.minTerminationDate && this.form.resignation_termination_date < this.minTerminationDate) {
          return "Termination Date must be after Joining Date (" + this.formatDate(this.minTerminationDate) + ")";
        }
        if (this.maxTerminationDate && this.form.resignation_termination_date > this.maxTerminationDate) {
          return "Termination Date must be before the next job's joining date (" + this.formatDate(this.maxTerminationDate) + ")";
        }
      }
      return "";
    },
    // Updated by Jarir 2026-03-25 : frontend sort/paginate
    filteredData() {
      var sortKey = this.sortKey;
      var order = this.sortOrders[sortKey] || 1;
      var list = (this.items || []).slice();
      if (sortKey) {
        var index = this.getIndex(this.columns, "name", sortKey);
        list = list.sort(
          function (a, b) {
            a = String(a[sortKey]).toLowerCase();
            b = String(b[sortKey]).toLowerCase();
            if (
              this.columns[index] &&
              this.columns[index].type &&
              this.columns[index].type == "date"
            ) {
              return (
                (a == b
                  ? 0
                  : new Date(a).getTime() > new Date(b).getTime()
                  ? 1
                  : -1) * order
              );
            }
            return (a == b ? 0 : a > b ? 1 : -1) * order;
          }.bind(this),
        );
      }
      return list;
    },
    paginatedData() {
      return this.paginate(
        this.filteredData,
        this.length,
        this.pagination.currentPage,
      );
    },
    // Updated 2026-07-13 — active record is determined by the backend's is_active flag, not by checking resignation_termination_date on the frontend
    activeRecordId() {
      if (!this.items || this.items.length == 0) return null;
      var active = this.items.find((item) => item.is_active == 1);
      return active ? active.id : null;
    },
  },
  created() {
    this.fetchData();
    this.fetchSignatories();
  },
  mounted() {},
  methods: {
    addDays(dateStr, days) {
      if (!dateStr) return null;
      let date = new Date(dateStr);
      date.setDate(date.getDate() + days);
      let yyyy = date.getFullYear();
      let mm = String(date.getMonth() + 1).padStart(2, '0');
      let dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    // Updated by Jarir 2026-04-09 — Recursively scan form for HTML tags / PHP code
    findHtmlOrPhpField(data, prefix) {
      var pattern = /<[a-zA-Z!?\/]/;
      if (data === null || data === undefined) return null;
      if (typeof data === "string") {
        if (data && pattern.test(data)) return prefix || "field";
        return null;
      }
      if (typeof data === "object") {
        for (var key in data) {
          if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
          var field = prefix ? prefix + "." + key : key;
          var hit = this.findHtmlOrPhpField(data[key], field);
          if (hit) return hit;
        }
      }
      return null;
    },
    // Updated by Jarir 2026-04-20 — Reject fields that contain only special chars (no letters/numbers)
    // Accepts Latin (a-z A-Z), Digits (0-9) and Bengali (\u0980-\u09FF) characters as valid
    findSpecialCharOnlyField(data, prefix) {
      var letterPattern = /[a-zA-Z0-9\u0980-\u09FF]/;
      if (data === null || data === undefined) return null;
      if (typeof data === "string") {
        var trimmed = data.trim();
        if (trimmed.length > 0 && !letterPattern.test(trimmed)) return prefix || "field";
        return null;
      }
      if (typeof data === "object") {
        for (var key in data) {
          if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
          var field = prefix ? prefix + "." + key : key;
          var hit = this.findSpecialCharOnlyField(data[key], field);
          if (hit) return hit;
        }
      }
      return null;
    },
    // Updated by Jarir 2026-03-30
    // Updated by Jarir 2026-04-23 — removed employee_id from body; backend reads from session only
    fetchSignatories() {
      axios
        .post(this.apiPrefix + "/get-signatories", {})
        .then((response) => {
          this.signatories = response.data || [];
        })
        .catch((error) => {
          console.error("Error loading signatories:", error);
        });
    },
    onSignatoryChange(sigId) {
      if (!sigId) {
        this.ownerSigPreview = null;
        return;
      }
      var found = null;
      for (var i = 0; i < this.signatories.length; i++) {
        if (this.signatories[i].id == sigId) {
          found = this.signatories[i];
          break;
        }
      }
      if (found && found.signature) {
        var path = "/images/company/signature/" + found.signature;
        this.fetchAsBlob(path).then(
          function (b) {
            this.ownerSigPreview = b;
          }.bind(this),
        );
      } else {
        this.ownerSigPreview = null;
      }
    },
    fetchAsBlob(url) {
      if (!url) return Promise.resolve(null);
      if (url.startsWith("data:")) return Promise.resolve(url);
      return fetch(url, { credentials: "same-origin" })
        .then((r) => r.blob())
        .then((blob) => URL.createObjectURL(blob))
        .catch(() => url);
    },
    openAddModal() {
      this.resetForm();
      this.showModal = true;
      // Pre-fetch signatures for pre-visualization in modal
      this.fetchCurrentSignatures();
    },
    fetchCurrentSignatures() {
      // We can fetch from WorkerIdentificationDocument endpoint
      axios
        .get(this.apiPrefix + "/worker-identification")
        .then((response) => {
          const doc = response.data;
          // Updated by Jarir 2026-04-26 — backend returns base64 data URIs; pass directly, not baseUrl+path
          if (doc.owner_signature) {
            this.owner_signature_raw = doc.owner_signature;
            this.fetchAsBlob(doc.owner_signature).then((b) => { this.ownerSigPreview = b; });
          } else {
            this.ownerSigPreview = null;
            this.owner_signature_raw = null;
          }
          if (doc.signature) {
            this.worker_signature_raw = doc.signature;
            this.fetchAsBlob(doc.signature).then((b) => { this.workerSigPreview = b; });
          } else {
            this.workerSigPreview = null;
            this.worker_signature_raw = null;
          }
          if (doc.worker_thumb_impression) {
            this.thumb_impression_raw = doc.worker_thumb_impression;
            this.fetchAsBlob(doc.worker_thumb_impression).then((b) => { this.thumbImpPreview = b; });
          } else {
            this.thumbImpPreview = null;
            this.thumb_impression_raw = null;
          }
        });
    },
    fetchData() {
      this.loading = true;
      axios
        .get(this.apiPrefix + "/employment-details")
        .then((response) => {
          this.items = response.data.records || [];
          this.loading = false;
          this.items.forEach((item) => {
            // Updated by Jarir 2026-04-26 — backend returns base64 data URIs; pass directly
            if (item.owner_signature) {
              this.fetchAsBlob(item.owner_signature).then((b) => { this.$set(item, "_ownerBlob", b); });
            }
            if (item.worker_signature) {
              this.fetchAsBlob(item.worker_signature).then((b) => { this.$set(item, "_workerBlob", b); });
            }
            if (item.worker_thumb_impression) {
              this.fetchAsBlob(item.worker_thumb_impression).then((b) => { this.$set(item, "_thumbBlob", b); });
            }
          });
        })
        .catch((error) => {
          this.$bvToast.toast("Error loading records", {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
          this.loading = false;
        });
    },
    onFileChange(e, type) {
      const file = e.target.files[0];
      if (!file) return;

      if (type === "owner_signature") {
        this.ownerSigFile = file;
        this.ownerSigName = file.name;
        this.ownerSigPreview = URL.createObjectURL(file);
      } else if (type === "worker_signature") {
        this.workerSigFile = file;
        this.workerSigName = file.name;
        this.workerSigPreview = URL.createObjectURL(file);
      } else if (type === "worker_thumb_impression") {
        this.thumbImpFile = file;
        this.thumbImpName = file.name;
        this.thumbImpPreview = URL.createObjectURL(file);
      }
    },
    // Updated by Jarir 2026-03-30 : Added required field validation
    saveDetail() {
      this.submitAttempted = true;
      var errors = [];
      if (!this.form.factory_name_address.en)
        errors.push("Factory Name & Address (English)");
      if (!this.form.owner_authority_name.en)
        errors.push("Owner/Management Name (English)");
      if (!this.form.joining_date) {
        errors.push("Joining Date");
      } else {
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateRegex.test(this.form.joining_date)) {
          errors.push("Joining Date must be in YYYY-MM-DD format");
        }
      }

      const isActive = this.isEdit && this.editId === this.activeRecordId;
      if (!isActive) {
        if (!this.form.resignation_termination_date) {
          errors.push("Termination Date is required");
        } else {
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (!dateRegex.test(this.form.resignation_termination_date)) {
            errors.push("Termination Date must be in YYYY-MM-DD format");
          }
        }
      }

      if (errors.length > 0) {
        this.$bvToast.toast("Please fill all required fields: " + errors.join(", "), {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      if (!isActive && this.form.joining_date >= this.form.resignation_termination_date) {
        this.$bvToast.toast("Joining Date must be earlier than Termination Date.", {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      if (this.form.joining_date < "1970-01-01") {
        this.$bvToast.toast("Joining Date cannot be earlier than 1970-01-01.", {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      let activeJoining = null;
      let previousJobs = [];

      this.items.forEach((item) => {
        let id = item.id;
        let joining = item.joining_date;
        let resignation = item.resignation_termination_date;

        if (this.isEdit && id === this.editId) {
          joining = this.form.joining_date;
          resignation = this.form.resignation_termination_date;
        }

        let joiningStr = joining ? String(joining).substring(0, 10) : null;
        let resignationStr = resignation ? String(resignation).substring(0, 10) : null;

        if (!resignationStr) {
          activeJoining = joiningStr;
        } else {
          previousJobs.push({
            id: id,
            joining_date: joiningStr,
            resignation_termination_date: resignationStr
          });
        }
      });

      if (!this.isEdit) {
        let joiningStr = String(this.form.joining_date).substring(0, 10);
        let resignationStr = String(this.form.resignation_termination_date).substring(0, 10);
        previousJobs.push({
          id: null,
          joining_date: joiningStr,
          resignation_termination_date: resignationStr
        });
      }

      previousJobs.sort((a, b) => a.joining_date.localeCompare(b.joining_date));

      if (!this.isEdit) {
        const newRecordIndex = previousJobs.findIndex((job) => job.id === null);
        if (newRecordIndex !== 0) {
          this.$bvToast.toast("Any new employment record must be older than the oldest existing record.", {
            title: "Sequential Date Conflict",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
          return;
        }
      }

      for (let k = 0; k < previousJobs.length; k++) {
        if (k > 0) {
          if (previousJobs[k].joining_date <= previousJobs[k - 1].resignation_termination_date) {
            this.$bvToast.toast("Dates must not overlap with the previous job's resignation date (" + previousJobs[k - 1].resignation_termination_date + ").", {
              title: "Sequential Date Conflict",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            });
            return;
          }
        }

        if (k === previousJobs.length - 1) {
          if (activeJoining && previousJobs[k].resignation_termination_date >= activeJoining) {
            this.$bvToast.toast("Resignation/Termination Date must be earlier than the contracted start date (" + activeJoining + ").", {
              title: "Sequential Date Conflict",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            });
            return;
          }
        } else {
          if (previousJobs[k].resignation_termination_date >= previousJobs[k + 1].joining_date) {
            this.$bvToast.toast("Dates must not overlap with the next job's joining date (" + previousJobs[k + 1].joining_date + ").", {
              title: "Sequential Date Conflict",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            });
            return;
          }
        }
      }

      // Updated by Jarir 2026-04-09 — Block HTML tags / PHP code in any text field
      var badField = this.findHtmlOrPhpField(this.form);
      if (badField) {
        this.$bvToast.toast("Invalid Input", {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      // Updated by Jarir 2026-04-20 — Reject fields containing only special characters
      var specialOnly = this.findSpecialCharOnlyField(this.form);
      if (specialOnly) {
        this.$bvToast.toast(
          "Fields must contain letters or numbers. You cannot save with only special characters (@#$%^ etc).",
          {
            title: "Validation Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          },
        );
        return;
      }

      this.saving = true;
      let formData = new FormData();

      formData.append(
        "factory_name_address",
        JSON.stringify(this.form.factory_name_address),
      );
      formData.append(
        "owner_authority_name",
        JSON.stringify(this.form.owner_authority_name),
      );
      formData.append(
        "reason_of_termination",
        JSON.stringify(this.form.reason_of_termination),
      );
      formData.append("joining_date", this.form.joining_date);
      formData.append(
        "resignation_termination_date",
        this.form.resignation_termination_date,
      );

      if (this.ownerSigFile) {
        formData.append("owner_signature", this.ownerSigFile);
      }
      if (this.workerSigFile) {
        formData.append("worker_signature", this.workerSigFile);
      }
      if (this.thumbImpFile) {
        formData.append("worker_thumb_impression", this.thumbImpFile);
      }

      // Updated by Jarir 2026-04-23 — employee_id removed from body; backend reads from session only

      // Updated by Jarir 2026-03-30
      if (this.selected_signatory_id) {
        formData.append("signatory_id", this.selected_signatory_id);
      }

      const url = this.isEdit
        ? `${this.$api_url}${this.apiPrefix}/employment-details/${this.editId}`
        : `${this.$api_url}${this.apiPrefix}/employment-details`;

      axios
        .post(url, formData)
        .then((response) => {
          this.$bvToast.toast(
            this.isEdit ? "Updated successfully" : "Saved successfully",
            {
              title: "Success",
              variant: "success",
              solid: true,
              autoHideDelay: 3000,
            },
          );
          this.showModal = false;
          this.fetchData();
          this.saving = false;
        })
        .catch((error) => {
          const msg = error.response && error.response.data && error.response.data.error ? error.response.data.error : "Error saving data";
          this.$bvToast.toast(msg, {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
          this.saving = false;
        });
    },
    editItem(item) {
      this.isEdit = true;
      this.editId = item.id;
      // Updated by Jarir 2026-04-21 : track autofetched status
      this.isAutofetched = item.is_autofetched == 1;

      // Safely parse JSON fields
      const parseJsonField = (field) => {
        if (!field) return { en: "", bn: "" };
        if (typeof field === "object") return field;
        if (typeof field === "string") {
          try {
            return JSON.parse(field);
          } catch (e) {
            return { en: field, bn: "" };
          }
        }
        return { en: "", bn: "" };
      };

      this.form = {
        factory_name_address: parseJsonField(item.factory_name_address),
        owner_authority_name: parseJsonField(item.owner_authority_name),
        reason_of_termination: parseJsonField(item.reason_of_termination),
        joining_date: (item.joining_date + "").substring(0, 10),
        resignation_termination_date: item.resignation_termination_date
          ? (item.resignation_termination_date + "").substring(0, 10)
          : "",
      };
      // Updated by Jarir 2026-03-30 — set selected signatory from record
      this.selected_signatory_id = item.signatory_id || null;

      // Updated by Jarir 2026-04-26 — backend returns base64 data URIs; pass directly
      if (item.owner_signature) {
        this.owner_signature_raw = item.owner_signature;
        this.fetchAsBlob(item.owner_signature).then((b) => { this.ownerSigPreview = b; });
      } else {
        this.ownerSigPreview = null;
        this.owner_signature_raw = null;
      }
      if (item.worker_signature) {
        this.worker_signature_raw = item.worker_signature;
        this.fetchAsBlob(item.worker_signature).then((b) => { this.workerSigPreview = b; });
      } else {
        this.workerSigPreview = null;
        this.worker_signature_raw = null;
      }
      if (item.worker_thumb_impression) {
        this.thumb_impression_raw = item.worker_thumb_impression;
        this.fetchAsBlob(item.worker_thumb_impression).then((b) => { this.thumbImpPreview = b; });
      } else {
        this.thumbImpPreview = null;
        this.thumb_impression_raw = null;
      }
      this.showModal = true;
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to delete this record? This cannot be undone.",
          {
            title: "Confirm Delete",
            okVariant: "danger",
            okTitle: "Delete",
            cancelTitle: "Cancel",
          },
        )
        .then((confirmed) => {
          if (confirmed) {
            axios
              .delete(
                `${this.$api_url}${this.apiPrefix}/employment-details/${id}`,
                {
                  // Updated by Jarir 2026-04-23 — employee_id removed; backend reads from session only
                },
              )
              .then(() => {
                this.$bvToast.toast("Deleted successfully", {
                  title: "Success",
                  variant: "success",
                  solid: true,
                  autoHideDelay: 3000,
                });
                this.fetchData();
              })
              .catch((err) => {
                // Updated by Jarir 2026-05-04 — show server-side error message if delete fails (e.g. active record)
                const msg = err.response && err.response.data && err.response.data.error ? err.response.data.error : "Error deleting record";
                this.$bvToast.toast(msg, { title: "Error", variant: "danger", solid: true, autoHideDelay: 5000 });
              });
          }
        });
    },
    resetForm() {
      this.isEdit = false;
      this.editId = null;
      this.isAutofetched = false; // Updated by Jarir 2026-04-21
      // Updated by Jarir 2026-04-20 — clear submit flag so red borders don't persist on next open
      this.submitAttempted = false;
      this.form = {
        factory_name_address: { en: "", bn: "" },
        owner_authority_name: { en: "", bn: "" },
        reason_of_termination: { en: "", bn: "" },
        joining_date: "",
        resignation_termination_date: "",
      };
      this.ownerSigFile = null;
      this.workerSigFile = null;
      this.thumbImpFile = null;
      this.ownerSigName = "";
      this.workerSigName = "";
      this.thumbImpName = "";
      this.ownerSigPreview = null;
      this.workerSigPreview = null;
      this.thumbImpPreview = null;
      this.selected_signatory_id = null;
    },
    downloadWithName(path, name) {
      if (!path) return;
      if (path.startsWith('data:image/')) {
        try {
          const parts = path.split(';base64,');
          const contentType = parts[0].split(':')[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) uInt8Array[i] = raw.charCodeAt(i);
          const blob = new Blob([uInt8Array], { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = name + '.' + contentType.split('/')[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
          return;
        } catch (e) {
          console.error("Base64 download failed, falling back to direct URL", e);
        }
      }
      const url = path.startsWith("http") || path.startsWith("data:") ? path : "/" + path;
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getJsonValue(field, lang) {
      if (!field) return "";

      // If field is already an object, access the property directly
      if (typeof field === "object" && field !== null) {
        return field[lang] || "";
      }

      // If field is a string, try to parse it as JSON
      if (typeof field === "string") {
        try {
          const parsed = JSON.parse(field);
          return parsed[lang] || "";
        } catch (e) {
          return field; // Return as-is if not valid JSON
        }
      }

      return "";
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.bg-light-blue {
  background-color: rgb(234, 246, 255) !important;
}
.bg-light-cyan {
  background-color: #e0f7fa;
}
.bn-text {
  font-family: "SolaimanLipi", sans-serif;
}
.sig-thumb {
  max-height: 50px;
  object-fit: contain;
}
.custom-table th {
  vertical-align: middle;
  font-size: 0.9rem;
}
.custom-table td {
  vertical-align: middle;
}
.add-entry-btn {
  font-weight: 600;
}

/* Sorting styles */
/* alpha fix- chnaged storting style here  */
.sorting { position: relative; padding-right: 30px !important; }
.sorting:after, .sorting:before { position: absolute; bottom: 0.9em; display: block; opacity: 0.3; font-family: 'Font Awesome 5 Free'; font-weight: 900; }
.sorting:before { right: 1em; content: "\f0de"; }
.sorting:after  { right: 1em; content: "\f0dd"; top: 1.1em; }
.sorting_asc:before  { content: "\f0de"; font-family: "Font Awesome 5 Free"; font-weight: 900; float: right; color: #000; }
.sorting_desc:after  { content: "\f0dd"; font-family: "Font Awesome 5 Free"; font-weight: 900; float: right; color: #000;}

.sorting_asc:after  {content: "\f0dd"; font-family: "Font Awesome 5 Free"; font-weight: 900; float: right; color: #ccc; }
.sorting_desc:before  { content: "\f0de"; font-family: "Font Awesome 5 Free"; font-weight: 900; float: right; color: #ccc;}

.add-entry-btn {
  /* border-radius: 20px; */
  font-weight: 500;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
